import AccessoryCommon from "./accessoryCommon";
import {Shower} from "../../parts/shower";
import {applyFeatureToLayerPosition} from "../../../../look/lookNavigation/lookFunctions";
import {ShowerHeadTypes} from "../../../../look/core/constants";

export default class HandleShowerValve extends AccessoryCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'handle_shower_valve';
    this.partName = 'Handle Shower Valve';
    this.translateId = "visualizer.bathroom.accessories.handle_shower_valve";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      this.oneLayerPosition = true;
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    return super.loadAsBV6(dbFeature);
  }

  navigationSubItems(filters, searchText) {
    return this.navigationSubItemsWithSides(filters, searchText);
  }

  disabledClick() {
    if (!this.disabled && this.activeFeature) {
      this.checkForOneMountType(this.activeFeature);
    }
  }

  checkForOneMountType = (clickedFeature) => {
    if (Array.isArray(clickedFeature?.dbFeature?.metaData["MountType"]) && clickedFeature.metaData["MountType"].length === 1
      && clickedFeature.metaData["MountType"][0] === "S") {
      const showerParent = this.getParent().layout.parts[Shower.id];
      const showerAccParent = this.getParent();
      if (showerParent?.showerArm?.activeFeature && !showerParent.showerArm.disabled
        && showerParent.shower_head_type === ShowerHeadTypes.shower_arm
        && showerAccParent?.handShowerKit?.activeFeature && !showerAccParent.handShowerKit.disabled) {
        showerAccParent.handShowerKit.disabled = true;
      }
    } else if (Array.isArray(clickedFeature?.dbFeature?.metaData["MountType"]) && clickedFeature.metaData["MountType"].includes("D")) {
      const showerParent = this.getParent().layout.parts[Shower.id];
      const showerAccParent = this.getParent();
      if (showerParent?.showerArm?.disabled && showerParent.shower_head_type === ShowerHeadTypes.shower_arm) {
        showerParent.showerArm.disabled = false;
        if (showerParent?.showerHead?.disabled) {
          showerParent.showerHead.disabled = false;
        }
      }
      if (showerAccParent?.handShowerKit?.disabled) {
        showerAccParent.handShowerKit.disabled = false;
      }
    }
  }

  checkValveMountType = () => {
    const showerParent = this.getParent().layout.parts[Shower.id];
    const showerAccParent = this.getParent();
    if (showerParent?.showerArm?.activeFeature && !showerParent.showerArm.disabled
      && showerParent.shower_head_type === ShowerHeadTypes.shower_arm
      && showerAccParent?.handShowerKit?.activeFeature && !showerAccParent.handShowerKit.disabled
      && !this.disabled && this.activeFeature && Array.isArray(this.activeFeature.metaData["MountType"])
      && showerAccParent.handleShowerValve.activeFeature.metaData["MountType"].includes("S")
      && !showerAccParent.handleShowerValve.activeFeature.metaData["MountType"].includes("D")) {
      // S is not compatible with both Shower Arm and Hand shower kit, we should use D for both
      const conditions = showerAccParent.handleShowerValve.getActiveFeatureConditions();
      conditions.push({
        propName: "MountType",
        propValue: "D"
      })
      conditions.push({
        propName: "Side",
        propValue: this.activeFeature.metaData["layerPosition"]
      })
      const navItems = showerAccParent.handleShowerValve.navigationSubItems()
        .filter(navItem => navItem.part.matchesMetaForArrayOfConditions(conditions));
      if (navItems[0]) {
        navItems[0].part.handleClick();
        applyFeatureToLayerPosition(navItems[0].part);
      }
    }
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Accessories.HandleShowerValve;
    }
  }

}
